import { z } from 'zod'

export const STAFF_NAME_MAX = 80
export const STAFF_PASSWORD_MIN = 10
export const STAFF_PASSWORD_MAX = 200

/** invited — the link is out, no password yet; active — can sign in; disabled — sign-in and sessions are off. */
export const staffStatusSchema = z.enum(['invited', 'active', 'disabled'])

export const staffMemberSchema = z.object({
  id: z.string(),
  email: z.email(),
  name: z.string(),
  status: staffStatusSchema,
  inviteExpiresAt: z.string().nullable(),
  lastLoginAt: z.string().nullable(),
  createdAt: z.string(),
  createdBy: z.string(),
})

export const staffListSchema = z.object({
  available: z.boolean(),
  members: z.array(staffMemberSchema),
})

export const createStaffRequestSchema = z.object({
  email: z.email('Проверьте почту — кажется, в адресе опечатка.').transform((value) => value.trim().toLowerCase()),
  name: z
    .string()
    .trim()
    .min(1, 'Напишите имя — его увидят клиенты в чате.')
    .max(STAFF_NAME_MAX, `Имя длиннее ${STAFF_NAME_MAX} символов.`),
})

/** The invite link is returned only here and on reissue; the server keeps just its hash. */
export const staffInviteSchema = z.object({
  member: staffMemberSchema,
  inviteUrl: z.url(),
})

export const inviteInfoSchema = z.object({
  email: z.email(),
  name: z.string(),
  expiresAt: z.string(),
})

/** The token travels in the URL fragment and the request body, never in a path that proxies would log. */
export const inviteTokenRequestSchema = z.object({
  token: z.string().trim().min(1, 'Ссылка неполная — откройте её целиком.').max(200),
})

export const acceptInviteRequestSchema = inviteTokenRequestSchema.extend({
  password: z
    .string()
    .min(STAFF_PASSWORD_MIN, `Пароль — минимум ${STAFF_PASSWORD_MIN} символов.`)
    .max(STAFF_PASSWORD_MAX, `Пароль длиннее ${STAFF_PASSWORD_MAX} символов.`),
})

export type StaffStatus = z.infer<typeof staffStatusSchema>
export type StaffMember = z.infer<typeof staffMemberSchema>
export type StaffList = z.infer<typeof staffListSchema>
export type CreateStaffRequest = z.input<typeof createStaffRequestSchema>
export type StaffInvite = z.infer<typeof staffInviteSchema>
export type InviteInfo = z.infer<typeof inviteInfoSchema>
export type InviteTokenRequest = z.infer<typeof inviteTokenRequestSchema>
export type AcceptInviteRequest = z.infer<typeof acceptInviteRequestSchema>
